import defaultAttributes from '../defaultAttributes';

const ListX = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M11 12H3' }],
    ['path', { d: 'M16 6H3' }],
    ['path', { d: 'M16 18H3' }],
    ['path', { d: 'm19 10-4 4' }],
    ['path', { d: 'm15 10 4 4' }],
  ],
];

export default ListX;
